module.exports = __webpack_public_path__ + "media/images/gallery/border_off-d928eb2647a2b9810b12116a93c929dd.gif";